export const charts = {
  alarms: {
    'Product Alarm': `rgb(32, 36, 162)`,
    Warning: `rgb(255, 178, 102)`,
    Critical: `rgb(255, 74, 74)`
  },
  avureAlarms: {
    'B-Alarm': `rgb(32, 36, 162)`,
    'C-Alarm': `rgb(255, 178, 102)`,
    'A-Alarm': `rgb(255, 74, 74)`
  },
  dsiAlarms: {
    'B-Alarm': `rgb(32, 36, 162)`,
    'C-Alarm': `rgb(255, 178, 102)`,
    'A-Alarm': `rgb(255, 74, 74)`
  },
  proteinAlarms: {
    'Critical Alarm': 'rgb(239, 68, 68)',
    Alarm: 'rgb(166, 162, 210)',
    'Warning Information': 'rgb(95, 92, 101)',
    '': 'rgb(229, 227, 227)',
    undefined: 'rgb(229, 227, 227)'
  }
};
